import CustomButton from "../../components/customButton";

const CandidateCompletion = ( ) => {

    const onDashboard=()=>{

        

        return

    }

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center min-vh-100  bg-light" style={{maxWidth:'100%'}}>
      <div className="card shadow-sm w-100" style={{ maxWidth: '450px',padding:"2px" }}>
        <div className="card-body text-center">
          {/* Strictly neutral: Information icon, no checks, no colors indicating pass/fail */}
          <div className="text-secondary mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
            </svg>
          </div>
          <h4 className="h3 fw-bold text-dark mb-1">Screening Complete</h4>
          <p className="text-lg text-muted mb-4">
            Your screening responses have been securely recorded and shared with the hiring team. You will be notified regarding the next steps in the process within 3-5 business days.
          </p>
          <div className="d-grid">
            <CustomButton
            title='Return to Candidate dashboard'
            onClick={()=>{}}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateCompletion